import { DefaultOptions } from '@tanstack/react-query';
import { ApiFetcherError } from '@/lib/api-fetcher';

export const DEFAULT_QUERIES_OPTIONS: DefaultOptions['queries'] = {
  // * With SSR, we usually want to set some default staleTime above 0 to avoid refetching immediately on the client
  staleTime: 60 * 1000,
  refetchOnWindowFocus: process.env.NODE_ENV === 'development' ? false : true,
  retry: (failureCount, error) => {
    // * 400 系列都不 retry
    if (error instanceof ApiFetcherError) {
      const isClientError = Math.floor(error.status / 100) === 4;
      if (isClientError) return false;
    }
    return failureCount < 3;
  },
};
